import _extends from "@babel/runtime/helpers/extends";
//React
import React, { useCallback } from 'react';

//mui
import { Box, Grid, Typography } from '@mui/material';
import { useDropzone } from 'react-dropzone';

//interface

//utils
import { bytesToSize, getStorageLinks } from '../utils/util';

//lib
import i18n from '../i18n';
var DropZoneComponent = function DropZoneComponent(props) {
  var fileSize = bytesToSize(props.maxFileSize, 0);
  var onDrop = useCallback(function (acceptedFiles) {
    acceptedFiles.forEach(function (file) {
      var _props$uploadedDocs;
      var allowedExtension = props.allowedFormats;
      var validFile = allowedExtension.includes(file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase());
      if (!validFile) {
        props.validationError("".concat(i18n.t('REGISTRATION.DOCUMENT_NOT_SUPPORTED'), " ").concat(props.allowedFormats.join('/')));
      } else if (file.size > props.maxFileSize) {
        props.validationError("".concat(i18n.t('REGISTRATION.DOCUMENT_SIZE_NOT_SUPPORTED'), " ").concat(fileSize));
      } else if (props !== null && props !== void 0 && props.uploadedDocs && (props === null || props === void 0 || (_props$uploadedDocs = props.uploadedDocs) === null || _props$uploadedDocs === void 0 ? void 0 : _props$uploadedDocs.length) > 0) {
        props.validationError("".concat(i18n.t('REGISTRATION.DOCUMENT_LENGTH_EXCEEDED')));
      } else {
        props.validationError('');
        var fileArr = {};
        fileArr.documentName = file.name;
        fileArr.documentSize = file.size;
        props.fileUpload(fileArr, file);
      }
    });
  }, [props === null || props === void 0 ? void 0 : props.uploadedDocs]);
  var _useDropzone = useDropzone({
      onDrop: onDrop,
      disabled: props !== null && props !== void 0 && props.dcsCompanyId ? true : false
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(Box, getRootProps({
    style: {
      cursor: 'auto',
      '&:focus': {
        outline: 0
      }
    }
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      textAlign: 'center',
      border: '1px dashed #bcbfbf',
      height: '35px',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    component: "img",
    src: getStorageLinks(props === null || props === void 0 ? void 0 : props.environment).cdn + '/assets/img/browse-icon.png',
    alt: i18n.t('BROWSE_ICON_ALT'),
    sx: {
      width: '25px',
      height: '25px',
      cursor: 'pointer'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    component: 'label',
    sx: {
      fontSize: '0.8rem'
    },
    color: "secondary.dark"
  }, /*#__PURE__*/React.createElement(Box, {
    component: 'label',
    sx: {
      marginLeft: '10px',
      cursor: 'pointer'
    },
    color: "primary.main"
  }, i18n.t('REGISTRATION.BROWSE')), ' ', i18n.t('REGISTRATION.DRAG_HERE'))), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), {
    multiple: true,
    disabled: props !== null && props !== void 0 && props.dcsCompanyId ? true : false
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    component: 'p',
    color: "secondary.dark",
    sx: {
      fontSize: '0.7rem !important',
      textAlign: 'right !important',
      margin: '5px 0px !important'
    }
  }, " ".concat(i18n.t('REGISTRATION.MAX_FILE_SIZE'), " ").concat(fileSize))))));
};
export default DropZoneComponent;